import settings from '../settings';


import $ from 'jquery';
import sweetalert from 'sweetalert';

import nunjucks from 'nunjucks';
import preloadNunjucks from '../preload/nunjucks';
var nunjucksEnv = preloadNunjucks();
import Pikaday from 'pikaday'

import moment   from 'moment';

export default class CuratedDigest {

    postIds;

    constructor() {

        this.click__prepare_email_button = this.click__prepare_email_button.bind(this);
        this.click__curate_post = this.click__curate_post.bind(this);
        this.click__uncurate_post = this.click__uncurate_post.bind(this);
        this.click__cancel_button = this.click__cancel_button.bind(this);
        this.click__schedule_digest = this.click__schedule_digest.bind(this);
        this.change__schedule_time = this.change__schedule_time.bind(this);

        this.postIds = [];

        if ($('.user-profile').data('can-curate-digest') == 1) {
            $('#curate-digest--cancel').on('click', this.click__cancel_button);
            $('#curate-digest--prepare').on('click', this.click__prepare_email_button);

            $('body').on('click', '.digest-schedule-toggle', this.click__schedule_digest)
                     .on('change', '.digest-form input[name="date"]', this.change__schedule_time)
                     .on('change', '.digest-form select[name="hour"]', this.change__schedule_time)
                     .on('change', '.digest-form select[name="minute"]', this.change__schedule_time)
                     .on('change', '.digest-form select[name="ampm"]', this.change__schedule_time);


            $('.posts__list ')
              .on('click', '.post--amped .select--curate-post', this.click__curate_post)
              .on('click', '.post--amped .unselect--curate-post', this.click__uncurate_post);
        }
    }

    click__curate_post(ev) {
        let $me = $(ev.currentTarget),
            $post = $me.parents('article');

        $post.addClass('post--selected');
        $('img.post__avatar', $post).hide();
        $('.post__avatar-selected', $post).removeClass('visually-hidden').show();

        this.postIds.push($post.data('id'));

        this.update_export_href();

        this.renderDigestBar();
    }

    click__uncurate_post(ev) {
        let $me = $(ev.currentTarget),
            $post = $me.parents('article'),
            id = $post.data('id');

        $post.removeClass('post--selected');
        $('img.post__avatar', $post).show();
        $('.post__avatar-selected', $post).hide();

        var index = this.postIds.indexOf(id);
        if (index > -1) {
            this.postIds.splice(index, 1);
        }

        this.update_export_href();

        this.renderDigestBar();
    }

    click__schedule_digest(ev) {
        ev.preventDefault()

        let channelId = ($('.user-profile').data('current-channel-id') !== 'undefined' ? $('.user-profile').data('current-channel-id') : null),
            text = (channelId == null) ? 'all users' : 'all members of this channel';

        this.set_defaults();

        $('.digest-schedule-toggle').addClass('visually-hidden');
        $('.digest-schedule-selector').removeClass('visually-hidden');

        let strDate = $('.digest-form input[name="date"]').val(),
            intHour = Number($('.digest-form select[name="hour"]').val()),
            intMinute = Number($('.digest-form select[name="minute"]').val()),
            bIsPM = 'PM' == $('.digest-form select[name="ampm"]').val(),
            twentyFourHour = (bIsPM) ? (intHour == 12 ? 12 : 12 + intHour) : (intHour == 12) ? 0 : intHour,
            schedule_time = moment(
                strDate,
                'ddd MMM DD YYYY'
            ).format('YYYY-MM-DD') +
            ' ' +
            this.zeroPad(twentyFourHour) +
            ':' +
            this.zeroPad(intMinute) +
            ':00';

        if (channelId != null) {
            $('.sweet-alert--curated-digest .confirm').css({'padding-top': '2px'});
            $('.sweet-alert--curated-digest .confirm').css({'height': '55px'});
        }

        $('.sweet-alert--curated-digest .confirm').html("<i class='fa fa-clock-o'></i> Send to " + text + ' - ' + strDate + ' ' + intHour + ':' + this.zeroPad(intMinute) + ' ' + ((bIsPM) ? 'PM' : 'AM'));
    }

    update_export_href()
    {
        let url = '/posts?';

        for (var i = 0; i < this.postIds.length; ++i) {
            url += 'post_id[]=' + this.postIds[i] + '&';
        }

        url += 'format=text/csv';

        $('#curate-digest--export').attr('href', url);
    }

    click__prepare_email_button(ev) {

        let customerId = $('.user-profile').data('customer-id'),
            channelId = ($('.user-profile').data('current-channel-id') !== 'undefined' ? $('.user-profile').data('current-channel-id') : null),
            recipientString = (channelId == null) ? 'your team' : 'members of this channel',
            button = (channelId == null) ? 'all users' : 'all members of this channel';

        let params = {
                cancelButtonText: 'Close',
                customClass: 'sweet-alert--curated-digest',
                html: true,
                confirmButtonText: 'Send to ' + button,
                showCancelButton: true,
                showConfirmButton: true,
                text: nunjucksEnv.render('html/ui/curated-digest.html', { postIds : this.postIds, posts: this.postIds.length, recipient_string: recipientString, customerId: customerId, channelId: channelId }),
                title: 'Prepare a curated email digest'
            },

            // Build the callback handler for a 'submit'
            callback = (isConfirm) => {
                if (isConfirm) {

                    // Build a new request to share the post
                    let url = '/customers/' + customerId + '/curated-digests',
                    response

                    response = $.ajax({
                        headers: settings.api_headers,
                        url: url,
                        data: $('.digest-form').serialize(),
                        type: 'POST'
                    })

                    // Handle a failed return
                    response.fail((jqXHR, textStatus) => {
                        sweetAlert({
                            title: 'Sorry!',
                            text: 'There was a problem preparing your digest',
                            type: 'error'
                        })
                    })

                    // Handle a successful return
                    response.done((data, textStatus, jqXHR) => {

                        var success_text

                        success_text = 'Your email digest is now processing!'

                        sweetAlert({
                            title: 'Success!',
                            text: success_text,
                            type: 'success'
                        })


                    })

                    this.click__cancel_button(null);
                }
            };

        sweetalert(params, callback);

        var picker = new Pikaday({ field: $('#digest-date-picker')[0], format: 'ddd MMM DD YYYY', minDate: new Date() })

        return false;
    }

    click__cancel_button(ev) {
        let $bar = $('#curated-digest-toolbar');
        this.postIds = [];
        $('img.post__avatar').show();
        $('.post__avatar-selected').hide();
        $('.post').removeClass('post--selected');

        this.renderDigestBar();

        return false;
    }

    renderDigestBar()
    {
        let numPosts = this.postIds.length,
            $bar = $('#curated-digest-toolbar');

        if (numPosts == 0) {
            $bar.hide();
        } else {
            $bar.show();
        }

        $('#curated-posts-count').text(numPosts);
        if (numPosts > 1) {
            $('#curated-posts-plural').show();
        } else {
            $('#curated-posts-plural').hide();
        }
    }

    get_date_to_next_n_minutes(numMinutes) {
        let date = new Date()
        date.setMinutes(
            numMinutes * Math.ceil(
                date.getMinutes() / numMinutes
            )
        )
        return date
    }

    set_defaults() {
        let date = this.get_date_to_next_n_minutes(15),
        momDate = moment(date),
        $date = $('.digest-form input[name="date"]'),
        $hour = $('.digest-form select[name="hour"]'),
        $minute = $('.digest-form select[name="minute"]'),
        $ampm = $('.digest-form select[name="ampm"]')

        $date.val(momDate.format('ddd MMM DD YYYY'))
        $hour.val(momDate.format('h')); // 1-12
        $minute.val(momDate.format('mm')); // 00-59
        $ampm.val(momDate.format('A')) // AM/PN
    }

    change__schedule_time(ev) {
        let $me = $(ev.currentTarget),
            channelId = ($('.user-profile').data('current-channel-id') !== 'undefined' ? $('.user-profile').data('current-channel-id') : null),
            text = (channelId == null) ? 'all users' : 'all members of this channel',
            strDate = $('.digest-form input[name="date"]').val(),
            intHour = Number($('.digest-form select[name="hour"]').val()),
            intMinute = Number($('.digest-form select[name="minute"]').val()),
            bIsPM = 'PM' == $('.digest-form select[name="ampm"]').val(),
            twentyFourHour = (bIsPM) ? (intHour == 12 ? 12 : 12 + intHour) : (intHour == 12) ? 0 : intHour,
            schedule_time = moment(
                strDate,
                'ddd MMM DD YYYY'
            ).format('YYYY-MM-DD') +
            ' ' +
            this.zeroPad(twentyFourHour) +
            ':' +
            this.zeroPad(intMinute) +
            ':00',
            dateObj = moment(schedule_time).toDate()

        if (dateObj.getTime() < new Date().getTime()) {
            $('.sweet-alert--curated-digest .confirm').html("<i class='fa fa-clock-o'></i> Send to " + text + ' now');
            $('.digest-schedule-selector input').css({'border-color': '#F6777D'});
            $('.digest-schedule-selector select').css({'border-color': '#F6777D'});
        } else {
            $('.digest-schedule-selector input').css({'border-color': 'rgb(48, 185, 156)'});
            $('.digest-schedule-selector select').css({'border-color': 'rgb(48, 185, 156)'});
            $('.sweet-alert--curated-digest .confirm').html("<i class='fa fa-clock-o'></i> Send to " + text + ' - ' + strDate + ' ' + intHour + ':' + this.zeroPad(intMinute) + ' ' + ((bIsPM) ? 'PM' : 'AM'));
        }
    }

    zeroPad(number) {
        return 10 > number ? '0' + number : number
    }
}
